import { IGetAccountingParams } from "@shared/lib/types/accounting";
import { useQuery } from "@tanstack/react-query";
import { INVOICES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";

export function useGetInvoicesAggregates(
  params: Partial<IGetAccountingParams>
) {
  const { data, isFetching, isSuccess, error } = useQuery({
    queryKey: [...INVOICES_QUERY_KEY, params],
    queryFn: () =>
      AccountingService.getBrandInvoicesAggregates({
        ...params,
      }),
  });

  return {
    invoicesAggregates: data,
    isInvoicesAggregatesFetching: isFetching,
    isInvoicesAggregatesSuccess: isSuccess,
    invoicesAggregatesError: error,
  };
}
